import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2020 semantics GmbH
//  Date      : $Date: 2026-03-13 15:47:48 +0100 (Fri, 13 Mar 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 161511 $
//  Purpose   : backend header (L131Split layout)
// =============================================================================
// ---Third-party imports
import React from 'react';
import { Menu, Breadcrumb, Image } from 'semantic-ui-react';
// ---Framework imports
import { AutoPortal, Link, PortalTarget, VIcon, XMenu } from 'uix/components';
import { useRouter, useActions, useEffect, useSelector } from 'uix/hooks';
import { UserMenuItem } from 'uix/auth/components';
import { QuickSearchInput } from 'uix/modules/search/components';
import { Sel } from 'uix/registries';
// ---Local imports
import './header.global.css';
// ---Globals
const ClassTabPath = ({})=>{
    let { request } = useRouter();
    if (request.classname != 'test') return null;
    let { classname, tabname } = request;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Breadcrumb.Divider, {
                icon: "right angle"
            }),
            /*#__PURE__*/ _jsx(Breadcrumb.Section, {
                children: /*#__PURE__*/ _jsx(Link, {
                    classname: classname,
                    children: classname
                })
            }),
            /*#__PURE__*/ _jsx(Breadcrumb.Divider, {
                icon: "right angle"
            }),
            /*#__PURE__*/ _jsx(Breadcrumb.Section, {
                children: request.tabname
            })
        ]
    });
};
const customLink = (node)=>{
    // maybe jobs should implement tree/id
    if (node.datatype == 20) {
        if (node.subtype == 2) {
            return {
                classname: 'import',
                tabname: 'package'
            };
        } else if (node.subtype == 1) {
            return {
                classname: 'job',
                tabname: 'id'
            };
        } else {
            return {
                classname: 'job',
                tabname: 'list',
                id: null
            };
        }
    } else {
        return {};
    }
};
export const AdminHeader = ({})=>{
    let mountPortal = useActions('mountPortal');
    //XXX: this TabMenuPortal stuff looks fishy
    useEffect(()=>{
        return ()=>mountPortal({
                TabMenuPortal: false
            });
    }, []);
    return /*#__PURE__*/ _jsxs(XMenu, {
        padded: true,
        children: [
            /*#__PURE__*/ _jsx("span", {
                style: {
                    width: '1em'
                }
            }),
            /*#__PURE__*/ _jsx(PortalTarget, {
                id: "topPortal"
            }),
            /*#__PURE__*/ _jsxs(XMenu.Item, {
                position: "right",
                style: {
                    width: '15vw'
                },
                children: [
                    /*#__PURE__*/ _jsx(VIcon, {
                        name: "search"
                    }),
                    /*#__PURE__*/ _jsx(QuickSearchInput, {
                        fluid: true
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(UserMenuItem, {}),
            /*#__PURE__*/ _jsx(Menu.Item, {
                fitted: true,
                id: "TabMenuPortal",
                ref: ()=>mountPortal({
                        TabMenuPortal: true
                    })
            })
        ]
    });
};
